import { render, staticRenderFns } from "./CarouselList.vue?vue&type=template&id=79c645a9&"
import script from "./CarouselList.vue?vue&type=script&lang=js&"
export * from "./CarouselList.vue?vue&type=script&lang=js&"
import style0 from "./CarouselList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports